import { render, staticRenderFns } from "./bs_crcy.vue?vue&type=template&id=4a161d18&scoped=true&"
import script from "./bs_crcy.vue?vue&type=script&lang=js&"
export * from "./bs_crcy.vue?vue&type=script&lang=js&"
import style0 from "./bs_crcy.vue?vue&type=style&index=0&id=4a161d18&scoped=true&lang=less&"
import style1 from "./bs_crcy.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a161d18",
  null
  
)

export default component.exports